import React from "react";
import { Card, Text, Group } from "@mantine/core";
import { cn } from "../../lib/utils"; // Ensure this utility is correctly imported and typed

interface MarqueeProps {
  className?: string;
  reverse?: boolean;
  pauseOnHover?: boolean;
  children: React.ReactNode;
  vertical?: boolean;
  repeat?: number;
  [key: string]: any; // For any additional props
}

export default function Marquee({
  className = "", // Provide a default value for className
  reverse,
  pauseOnHover = false,
  children,
  vertical = false,
  repeat = 4,
  ...props
}: MarqueeProps) {
  return (
    <div
      {...props}
      className={cn(
        "group flex overflow-hidden p-2 [--duration:40s] [--gap:1rem] [gap:var(--gap)]",
        vertical ? "flex-col" : "flex-row",
        className
      )}
    >
      {Array(repeat)
  .fill(0)
  .map((_, i) => (
    <div
      key={i}
      className={cn(
        "flex shrink-0 justify-around [gap:var(--gap)]",
        vertical ? "animate-marquee-vertical flex-col" : "animate-marquee flex-row",
        pauseOnHover ? "group-hover:[animation-play-state:paused]" : "",
        reverse ? "[animation-direction:reverse]" : ""
      )}
    >
      {children}
    </div>
  ))}
    </div>
  );
}
